import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=83f3dd04&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "./Reset.vue?vue&type=style&index=0&id=83f3dd04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f3dd04",
  null
  
)

export default component.exports